import { defineMessages } from '@/components/formatted_message/FormattedMessage';
import { APP_DICTIONARY } from './root';

export const COMMON_FORM_FIELDS_TRANSLATED = defineMessages({
  dateFrom: { id: 'app.common.form.fields.dateFrom' },
  dateTo: { id: 'app.common.form.fields.dateTo' },
  phone: { id: 'app.common.form.fields.phone' },
  toolsId: { id: 'app.common.meter.fields.toolsId' },

  ...APP_DICTIONARY,

  attachments: APP_DICTIONARY.attachments,
});

export const COMMON_FORM_PLACEHOLDERS_TRANSLATED = defineMessages({
  note: { id: 'app.common.form.placeholders.note' },
});
